import constants from 'common/constants'

import {ONBOARDING_TIMETABLE_CURRICULA} from './ActionTypes/ApiActionTypes'

/**
 * GET timetable/curricula?countryCode=… — the curricula a school in that country can pick:
 * `{country: {code, name}, national_count, curricula: [{code, name, scope, awarding_body, …}]}`.
 * National boards come first (the first `national_count` entries), then the international
 * curricula offered everywhere; the order is "most likely answer first" and must be kept.
 * Also `common_curricula` (same item shape, most common first, every code also in `curricula`)
 * and `common_curricula_source` (`curated` | `default`) — the chip row of Setup Basics.
 * `countryCode` accepts an alpha-2 code or a full country name; omit it for the tenant's own
 * country. See docs/curriculum-prefill-frontend-integration.md.
 *
 * @param {string | null | undefined} countryCode
 */
export const getTimetableCurricula = (countryCode, onSuccess, onFailure) => {
  return {
    type: ONBOARDING_TIMETABLE_CURRICULA,
    payload: {
      apiUrl: constants.api_timetable_curricula,
      getString: countryCode ? `?countryCode=${encodeURIComponent(countryCode)}` : '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: null,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
